import {
  IAttendee,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getContactsCrud } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/cruds'
import { getFormedChangedComplexData } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedChangedCompexData'
import { RoundTableLabel } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/roundTable/components/roundTableLabel/RoundTableLabel'
import { RoundTableSection } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/roundTable/components/roundTableSection/RoundTableSection'
import { StyledTable } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'
import { Title } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/title/Title'
import { useCallback, useMemo } from 'react'

import { getFormedEltTranslation } from '../../../../helpers/getFormedEltTranslation'

import { getCompAttendeesColumns } from './getCompAttendeesColumns'

interface IProps {
  data: IAttendee[]
  updateFormData: (data: TComplexSectionData) => void
  groupId: number | null
  partnerId?: string
}

export const AccountAttendees = ({ data, updateFormData, groupId, partnerId }: IProps) => {
  const onChange = useCallback(
    (field: string, index: number) => (value: string) => {
      const newData = getFormedChangedComplexData<IAttendee>({ field, value, index, data })
      updateFormData(newData)
    },
    [data]
  )

  const addRow = useCallback(() => {
    const newData: IAttendee[] = [...data, { Email: '', Name: '', Title: '' }]
    updateFormData(newData)
  }, [data])

  const deleteLastRow = useCallback(() => {
    const newData = data.slice(0, -1)
    updateFormData(newData)
  }, [data])

  const deleteRow = useCallback(
    (index: number) => {
      const newData = data
      newData.splice(index, 1)
      updateFormData(newData)
    },
    [data]
  )

  const crud = useMemo(() => {
    return getContactsCrud({ groupId, partnerId })
  }, [partnerId, groupId])

  const canAddNewRow = useMemo(() => {
    const emptyRows = data.filter((el) => !el.Name && !el.Email && !el.Title)
    return emptyRows.length === 0
  }, [JSON.stringify(data)])

  const columns = useMemo(() => getCompAttendeesColumns({ onChange, crud }), [data, crud])
  return (
    <RoundTableSection>
      <div>
        <Title
          variant="withBackground"
          text={getFormedEltTranslation('account-attendees')}
          rightContent={<RoundTableLabel />}
        />
        <StyledTable<IAttendee>
          columns={columns}
          items={data}
          addRow={addRow}
          deleteLastRow={deleteLastRow}
          deleteRow={deleteRow}
          canAddNewRow={canAddNewRow}
          maxLen={5}
        />
      </div>
    </RoundTableSection>
  )
}
